module.exports = __webpack_public_path__ + "static/media/t2.8cfae2b1.png";